export default __webpack_public_path__ + "static/media/mh-bedroom-3rd-01.84e61692.jpg";